import { DOWNLOADS } from '../../../routes'

import useTranslations from '../../../i18n/useTranslations'

import PrintAlertView from './View'

const PrintAppNotInstalledAlertView = ({ closeAlert }) => {
  const t = useTranslations()

  return (
    <PrintAlertView
      description={t('print-alert:app-not-installed')}
      textButton={t('alert:go-to-download-page')}
      urlButton={DOWNLOADS.path}
      closeAlert={closeAlert}
    />
  )
}
PrintAppNotInstalledAlertView.propTypes = {
  closeAlert: PrintAlertView.propTypes.closeAlert,
}

export default PrintAppNotInstalledAlertView
